import resolveFormInputs from '@hbrisk/sp3-risk-model-support/utility/form/resolveFormInputs/index.js';
import byField from '@hbrisk/sp3-risk-model-support/utility/form/formInputsTransforms/byField/index.js';
import bySlice from '@hbrisk/sp3-risk-model-support/utility/form/formInputsTransforms/bySlice/index.js';
import { MODEL_NAME } from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import getFieldPermissionOverrides from '@hbrisk/sp3-risk-model-support/utility/form/getFieldPermissionOverrides/index.js';
import { modelTypesById } from '#constants/models/modelTypes/index.js';

// The payload common to every model type. Each per-type builder starts here and
// adds only the fields its create request schema permits.
const buildBasePayload = (baseModel, createdById, orgId, permissions) => {
  const { type, formInputs, advisories } = baseModel;
  const { [MODEL_NAME]: originalModelName } = formInputs;

  let newModelFormInputs = {
    ...formInputs,
    [MODEL_NAME]: {
      ...originalModelName,
      value: `${originalModelName.value} Copy`,
    },
  };
  const { fields } = modelTypesById[type];
  newModelFormInputs = bySlice(newModelFormInputs);

  const overrides = getFieldPermissionOverrides(fields, permissions);

  newModelFormInputs = resolveFormInputs(fields, {
    ...newModelFormInputs,
    visibleFields: {
      ...newModelFormInputs.visibleFields,
      ...overrides,
    },
  });

  newModelFormInputs = byField(newModelFormInputs, fields);

  return {
    createdById,
    orgId,
    type,
    formInputs: newModelFormInputs,
    // Document-level advisories are a copy-safe model column (AD-10/§3.5); carry them forward so a
    // copy of e.g. a MULTIPLE_BUILDINGS model keeps the only explanation for its empty sections.
    // Guarded, so a type with no advisories never sends the key -- type 3's create schema is
    // `additionalProperties: false` and only types 1 and 2 can be extracted.
    ...(advisories ? { advisories } : {}),
  };
};

export default buildBasePayload;
